import axios from "axios";

export const urlBase = process.env.REACT_APP_API_URL;

const urlResource = `${urlBase}/chatbot-resource-management-api/v1.0`

const authHeaders = {
  'x-api-key': 'vietrade-ai',
};

const uploadDocument = async ({files, conversationId, userId}) => {
    try {
        const formData = new FormData();
        // formData.append('files', file);
        files.forEach((file) => {
            formData.append('files', file);
        });
        formData.append('conversationId', conversationId);
        formData.append('userId', userId);

        const response = await axios.post(`${urlResource}/chatbot-web-document`, formData, {
            headers: {
                ...authHeaders,
                // 'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('uploadDocument error:', error);
        throw error;
    }
}

const getAllDocument = async (conversationId) => {
  try {
    const response = await axios.get(`${urlResource}/chatbot-web-document/`, {
      headers: {
        'x-api-key': 'vietrade-ai',
      },
      params: {
        searchs: `conversation_id==${conversationId}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error('getAllDocument error:', error);
    throw error;
  }
};

const getDocumentDetail = async ({ docId, conversationId }) => {
  try {
    const response = await axios.get(`${urlResource}/chatbot-web-document/${docId}`, {
      headers: {
        'x-api-key': 'vietrade-ai',
      },
      params: {
        conversationId,
      },
    });

    return response.data;
  } catch (error) {
    console.error('getDocumentDetail error:', error);
    throw error;
  }
};

const deleteDocument = async (conversationId, docId) => {
  try {
    const response = await axios.delete(`${urlResource}/chatbot-web-document`, {
      headers: {
        'x-api-key': 'vietrade-ai',
      },
      data: {
        conversationId,
        ids: [docId]
      },
    });

    return response.data; 
  } catch (error) {
    console.error('deleteDocuments error:', error);
    throw error;
  }
};

const DocumentAPI = {
    uploadDocument,
    getAllDocument,
    deleteDocument
}

export default DocumentAPI